const steps = [
  {
    number: '01',
    title: 'お問い合わせ・ご相談',
    icon: 'ri-chat-3-line',
    details: [
      'フォームまたは電話で気軽にお問い合わせ',
      '利用期間・印刷量・ご予算などをヒアリング',
      '最適な機種やプランを無料でご提案',
    ],
  },
  {
    number: '02',
    title: 'お見積り・機種のご提案',
    icon: 'ri-file-list-3-line',
    details: [
      '月額料金・保守内容・納期を明確に提示',
      '新品リースより"どれだけ安くなるか"も比較可能',
    ],
  },
  {
    number: '03',
    title: 'ご契約手続き',
    icon: 'ri-contract-line',
    details: [
      '面倒な審査なし',
      '契約書の確認後、スムーズに完了',
      '短期利用・スポット利用も柔軟に対応',
    ],
  },
  {
    number: '04',
    title: '納品・設置・初期設定',
    icon: 'ri-truck-line',
    details: [
      '専門スタッフがオフィスへ訪問',
      '設置・ネットワーク設定・動作確認まで対応',
      '当日からすぐに利用開始',
    ],
  },
  {
    number: '05',
    title: '保守サポート・トラブル対応',
    icon: 'ri-customer-service-2-line',
    details: [
      '故障時は迅速に修理&nbsp;',
      'トナー交換やメンテナンスもお任せ',
      '小規模オフィスでも安心して使える運用体制',
    ],
  },
];

export default function FlowSteps() {
  return (
    <section id="flow" className="py-24 bg-[#F5F1ED]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16">
          <div className="text-xs text-gray-500 font-light mb-3 tracking-wider">FLOW</div>
          <h2 className="text-5xl font-extrabold text-gray-900 leading-tight">
            <a href="#flow" className="hover:text-[#14B8A6] transition-colors cursor-pointer">
              導入の流れ
            </a>
          </h2>
          <p className="text-gray-500 mt-4 text-base">数日でご利用開始できます</p>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-[2.75rem] top-0 bottom-0 w-px bg-gray-200 hidden md:block" />

          <div className="space-y-8">
            {steps.map((step, index) => (
              <div key={index} className="flex gap-8 items-start group">
                {/* Icon circle */}
                <div className="relative shrink-0 w-22">
                  <div className="w-14 h-14 rounded-full bg-white border-2 border-[#14B8A6] flex items-center justify-center z-10 relative">
                    <i className={`${step.icon} text-xl text-[#14B8A6]`}></i>
                  </div>
                </div>

                {/* Content card */}
                <div className="flex-1 bg-white rounded-2xl p-8 mb-2">
                  <div className="flex items-center gap-4 mb-4">
                    <span className="text-xs font-bold text-[#14B8A6] tracking-widest">STEP {step.number}</span>
                    <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                  </div>
                  <ul className="space-y-2">
                    {step.details.map((detail, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#14B8A6] mt-0.5 shrink-0"></i>
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
